import { get } from 'lodash';

export const getCounter = (state, entityId) => state.counters[entityId];

export const getEntityViewCount = (state, entity) =>
  get(state.counters[entity._id], 'viewCount', get(entity, 'viewCount'));

export const getEntityLikeCount = (state, entity) =>
  get(state.counters[entity._id], 'likeCount', get(entity, 'likeCount'));
